import { Environment } from 'services/Environment';

export const AddressOnMap = ({ address }) => (
    <iframe
        width="100%"
        height="250"
        frameBorder="0"
        style={{ border: '0' }}
        src={`https://www.google.com/maps/embed/v1/place?key=${Environment.GOOGLE_MAPS_API_KEY}&q=${encodeURIComponent(Object.values(address).join(' '))}`}
        allowFullScreen
        title="Google maps embedded view"
        className="lazyload"
    ></iframe>
);
